<template>
  <main
    class="h-screen w-full max-w-screen-2xl mx-auto flex items-center justify-center relative"
  >
    <div class="absolute left-20 top-14 z-10">
      <oval v-if="tenantIsOval" size="h-12 w-12" />
      <torus v-else size="h-12 w-12" />
    </div>
    <admin-business-auth class="relative z-10" />
    <img
      :src="imgUrl"
      alt="meaningful"
      class="absolute left-0 top-0 bottom-0 right-0"
    />
  </main>
</template>

<script>
import { ADMIN_TENANT } from '@/utils/constants'
import ovalBackground from '@/assets/v2/images/OA1.png'
import torusBackground from '@/assets/v2/images/OA.png'
export default {
  components: {
    AdminBusinessAuth: () => import('@/components/v2/admin-business-auth'),
    oval: () => import('@/assets/v2/icons/OvalLogoIcon.vue'),
    torus: () => import('@/assets/v2/icons/TorusLogoIcon.vue')
  },
  computed: {
    tenantIsOval () {
      return localStorage.getItem(ADMIN_TENANT) === this.$tenants.OVAL
    },
    imgUrl () {
      return this.tenantIsOval ? ovalBackground : torusBackground
    }
  }
}
</script>
